<!--
 * @Author: your name
 * @Date: 2021-08-09 15:14:26
 * @LastEditTime: 2022-01-05 09:48:44
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\views\layout\components\top.vue
-->
<template>
    <div class="personal_right_content">
        <div class="per_right_top">
            <div class="per_top_left">
                <div class="per_msg_top">
                    <img src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/default_avatar_red.png" alt="">
                    <div class="per_msg_right">
                        <div>{{loginName}}</div>
                        <div class="company_address">
                            <div>企业：{{customer.fullName}}&emsp;</div>
                            <!-- <router-link to="">解绑</router-link>
                            <router-link to="">更改</router-link> -->
                        </div>
                    </div>
                </div>
                <!-- <div class="per_msg_address">
                    <div>收货地址：江苏省苏州工业园区东长路18号1幢</div>
                    <img src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/arrow_left.png" alt="">
                </div> -->
            </div>
            <div class="per_top_right">
                <div class="per_top_title">关注中心</div>
                <div class="focus_center">
                    <div class="focus_center_one" >
                        <span class="pointer"  @click=" $router.push('/personal/purchaseRecord')">{{buyGoodsCout}}</span>
                        <span  class="pointer" @click="$router.push('/personal/purchaseRecord')">购买记录</span>
        <!-- <router-link :to="{path: '/personal/purchaseRecord', query: {}}"><span>购买记录</span></router-link> -->
                    </div>
                    <div >
                        <span  class="pointer" @click="$router.push('/personal/collection_list')">{{collectionCount}}</span>
                        <span class="pointer" @click="$router.push('/personal/collection_list')">我的收藏</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="per_midder">
            <div class="per_midder_title">我的订单</div>
            <ul>
                <li @click="queryOrder('')">
                    <router-link to="">
                        <img src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/all_order.png" alt="">
                        <span class="strokeDiv">全部订单</span>
                    </router-link>
                </li>
                <li @click="queryOrder(1)">
                    <router-link to="">
                        <img src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/wait_pay.png" alt="">
                        <span class="strokeDiv">待付款</span>
                    </router-link>
                </li>
                <li @click="queryOrder(5)">
                    <router-link to="">
                        <img src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/wait_reviewed.png" alt="">
                        <span class="strokeDiv">待审核</span>
                    </router-link>
                </li>
                <li @click="queryOrder(10)">
                    <router-link to="">
                        <img src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/wait_shipped.png" alt="">
                        <span class="strokeDiv">待发货</span>
                    </router-link>
                </li>
                <li @click="queryOrder(20)">
                    <router-link to="">
                        <img src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/wait_received.png" alt="">
                        <span class="strokeDiv">待收货</span>
                    </router-link>
                </li>
                <li>
                    <router-link :to="{path: '/personal/backGoods', query: {}}">
                        <img src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/return_goods.png" alt="">
                        <span class="strokeDiv">退货/售后</span>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="last_order">
            <div class="last_order_title">最新订单</div>
            <no-order-list v-if="orderList.length == 0" />
            <div class="new_order_list" v-else>
                <div class="myorder_table_lable">
                    <div class="order_list_msg_02">商品信息</div>
                    <div class="order_list_msg_03">单价</div>
                    <div class="order_list_msg_03">数量</div>
                    <div class="order_list_msg_03">备注</div>
                    <div class="order_list_msg_03">实发数量</div>
                    <div class="order_list_msg_03">小计金额</div>
                    <!-- <div class="order_pay_status">支付状态</div> -->
                    <!-- <div class="order_shipment_status">发货状态</div> -->
                    <div class="order_operation">操作</div>
                </div>
                <order-list :orderList="orderList" />
            </div>
        </div>
    </div>
</template>
<script>
import { getOrderListData, getOrerStatusesData } from "@/api/customer/orderApi";
import { getCollectionListData } from "@/api/customer/collectionApi";
import store from "../../store/index";
import orderList from "./order/orderList.vue";
import NoOrderList from "../../components/personal/noOrderList.vue";
export default {
    components: { orderList, NoOrderList },
    data() {
        return {
            query: {},

            orderList: [],
            orerStatuses: [],

            currentPage: 1,
            total: 0,

            collectionCount: 0,
            buyGoodsCout: 0
        };
    },
    props: {
        customer: {
            type: Object,
            default: {},
        },
    },
    computed: {
        loginName: function () {
            return store.getters.getUserName;
        },
    },
    created: function () {
        this.customer.fromPage = "personalIndex";
        this.getOrderList();
        this.getCollectionList();
    },
    methods: {
        queryOrder: function (status) {
            // this.query.status = status;
            // this.getOrderList();
            this.$router.push({
                path: "/personal/myOrder",
                query: { status: status },
            });
        },
        getOrderList: function () {
            getOrderListData(this.currentPage, this.query).then((res) => {
                if (res.success) {
                    this.orderList = res.data.list;
                    if (this.total == 0) {
                        this.total = res.data.total;
                    }
                }
            });
        },
        getCollectionList: function () {
            getCollectionListData(1, null, null, 1).then((res) => {
                if (res.success) {
                    this.collectionCount = res.data.total;
                }
            });
            getCollectionListData(1, null, null, 2).then((res) => {
                if (res.success) {
                    this.buyGoodsCout = res.data.total;
                }
            });
        },
    },
};
</script>
<style scoped>
.personal_right_content {
    width: 959px;
    margin-top: 15px;
}
/* 右边上部 */
.per_right_top {
    width: 100%;
    display: flex;
    justify-content: flex-start;
}
.per_top_left {
    width: 402px;
    height: 185px;
    background-color: #fff;
    margin-right: 15px;
    padding: 0 42px 0 28px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}
.per_top_right {
    width: 445px;
    height: 185px;
    background-color: #fff;
    padding: 0 18px 0 9px;
    display: flex;
    flex-direction: column;
}
.per_msg_top {
    height: 125px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.per_msg_top img {
    width: 54px;
    height: 54px;
    margin-right: 19px;
}

.per_msg_right {
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}
.company_address {
    display: flex;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-top: 15px;
}
.company_address a {
    display: inline-block;
    color: #e1251b;
    padding: 0 3px;
}
.per_msg_address {
    width: 100%;
    height: 60px;
    border-top: 1px solid #f3f3f3;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}
.per_msg_address img {
    width: 12px;
    height: 12px;
}
.per_top_title {
    padding: 23px 0 20px 14px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    border-bottom: 1px solid #f3f3f3;
}
.per_midder_title,
.last_order_title {
    height: 15px;
    padding: 23px 0 19px 0px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    border-bottom: 1px solid #f3f3f3;
}
.focus_center {
    height: 126px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}
.focus_center div:nth-child(1) {
    margin-right: 131px;
}
.focus_center div {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.focus_center div span:nth-child(1) {
    font-size: 20px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 17px;
}
.pointer{
    cursor: pointer;
}
/* 我的订单 */
.per_midder {
    width: calc(100% - 60px);
    height: 185px;
    background-color: #fff;
    margin-top: 15px;
    padding: 0 28px 0 32px;
}
.per_midder ul {
    height: 126px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
}
.per_midder ul li a {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}
.per_midder ul li a:hover {
    color: #e1251b;
}
.per_midder ul li img {
    /*width: 24px;*/
    height: 24px;
    margin-bottom: 14px;
}
/* .active_status span{
    color: #2379EF;
} */
/* 最新订单 */
.last_order {
    width: calc(100% - 41px);
    min-height: 311px;
    background-color: #fff;
    margin-top: 15px;
    padding: 0 20px 1px 21px;
}
/* 商品信息表头 */
.myorder_table_lable {
    width: calc(100% - 25px);
    height: 37px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    background-color: #f4f4f4;
    border: 1px solid #e2e2e2;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin: 14px 0;
}
</style>


// WEBPACK FOOTER //
// src/views/personal/personal.vue